import "core-js/stable";
import "regenerator-runtime/runtime";
export * from "./lib";
import * as all from "./lib";
export default {
    buildS3Service: all.buildS3Service,
    useFileManager: all.useFileManager
};
